/**
 * StaffListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffListReq
 */
export interface StaffListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 员工列表筛选 */
  filter_preset?: string
  /** 是否超级管理员 */
  is_super_admin?: boolean
  /** 用户名包含 */
  username__like?: string
  /** 昵称包含 */
  nickname__like?: string
  /** 邮箱包含 */
  email__like?: string
  /** 最后登录时间距今 */
  last_login__since?: string
  /** 最后登录时间早于 */
  last_login__before?: string
}

/**
 * StaffListReq Schema
 */
export const StaffListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    filter_preset: {
      description: '员工列表筛选',
      format: 'cons.StaffListFilterPreset',
      type: 'string',
      label: '员工列表筛选',
    },
    is_super_admin: {
      description: '是否超级管理员',
      format: '*bool',
      type: 'boolean',
      label: '是否超级管理员',
    },
    username__like: {
      description: '用户名包含',
      format: 'string',
      type: 'string',
      label: '用户名包含',
    },
    nickname__like: {
      description: '昵称包含',
      format: 'string',
      type: 'string',
      label: '昵称包含',
    },
    email__like: {
      description: '邮箱包含',
      format: 'string',
      type: 'string',
      label: '邮箱包含',
    },
    last_login__since: {
      description: '最后登录时间距今',
      format: '*string',
      type: 'string',
      label: '最后登录时间距今',
    },
    last_login__before: {
      description: '最后登录时间早于',
      format: '*string',
      type: 'string',
      label: '最后登录时间早于',
    },
  },
  type: 'object',
}
